import { observer } from 'mobx-react-lite'
import { useMemo, useState } from 'react'
import { SpinnerLoader } from 'shared/ui'
import { type KnowledgeBaseDocument } from 'entities/KnowledgeBase'
import styles from './KnowledgeBaseDetailsModal.module.scss'

export const KnowledgeBaseDetailsModal = observer(
  ({ item, link }: { item: KnowledgeBaseDocument; link: string }) => {
    const [isLoading, setIsLoading] = useState(true)

    const iframeSrc = useMemo(() => {
      const extension = item.extension?.toLowerCase() || ''

      if (extension.includes('html')) {
        return link
      }
      if (extension.includes('xls') || extension.includes('xlsx')) {
        return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(link)}`
      }

      return `https://docs.google.com/gview?url=${encodeURIComponent(link)}&embedded=true`
    }, [item.extension, link])

    return (
      <div className={styles.container}>
        {isLoading && <SpinnerLoader ariaLabel={'KnowledgeBaseDetailsModal'} />}
        <iframe
          src={iframeSrc}
          className={styles.iframeWrapper}
          title={item.name}
          onLoad={() => setIsLoading(false)}
          allowFullScreen
          style={{ display: isLoading ? 'none' : 'block' }}
        />
      </div>
    )
  }
)
